import Phaser from 'phaser';

export default class extends Phaser.Physics.Arcade.Sprite {
  static preload(scene) {
    scene.load.audio('droplet', ['assets/sfx/droplet.mp3']);
  }

  get collected() {
    return this._collected;
  }

  markAsCollected() {
    this._collected = true;
  }

  constructor(config) {
    super(config.scene, config.x, config.y, 'water');
    this._collected = false;
    if (typeof this.anims.animationManager.get('ripple') === 'undefined') {
      const rippleAnimation = { key: 'ripple',
        frames: this.anims.animationManager.generateFrameNumbers('water', { start: 0, end: 3 }),
        frameRate: 4,
        repeatDelay: 500,
        repeat: -1
      };

      this.anims.animationManager.create(rippleAnimation);
    }
    if (typeof this.anims.animationManager.get('splash') === 'undefined') {
      const splashAnimation = { key: 'splash',
        frames: this.anims.animationManager.generateFrameNumbers('water', { start: 4, end: 7 }),
        frameRate: 8,
        repeat: 0
      };
      this.anims.animationManager.create(splashAnimation);
    }

    this.anims.play('ripple');

    this.x = config.x;
    this.y = config.y;

    this.scene.physics.add.existing(this, true);
    this.scene.add.existing(this);
  }

  splash() {
    this.markAsCollected();
    this.anims.play('splash');

    this.scene.tweens.add({
      delay: 500,
      targets: this,
      duration: 1000,
      alpha: 0
    });
  }
}